<template>
    <div>

        <el-form @submit.native.prevent="onSubmitTurma" style="min-height: 200px;" :model="dados" ref="dados" label-position="top">

            <div class="style-form u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="20" :md="20">
                        <label>Instituição</label>
                        <el-select disabled v-model="dados.instituicao_id">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <label>Período Letivo</label>
                        <el-form-item key="periodo">
                            <el-select disabled v-model="dados.periodo_letivo_id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item label="Nome da Turma" prop="nome" :rules="[$requiredBlur]" key="nome">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Cod. Censo" prop="inep" key="inep">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.inep" maxlength="191"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                        <el-select :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.situacao">
                            <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_TURMA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Quantidade de Vagas" prop="qtd_vagas" :rules="[$requiredBlur, $dataBlur]" key="qtd_vagas">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.qtd_vagas" maxlength="191" v-mask="'###'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Turno" prop="turno" :rules="[$requiredChange]" key="turno">
                        <el-select @change="getParametrosDiarioForTurma()" :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.turno">
                            <el-option v-for="(item, i) in $CONSTANTS.TURNO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Tipo de Ensino" prop="tipo_ensino" :rules="[$requiredChange]" key="tipo_ensino">
                        <el-select @change="getCursosByTipoEnsino" :disabled="editTurma" v-model="dados.tipo_ensino">
                            <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="$store.state.user.tipo == 4 || $store.state.user.tipo == 6 ? 12 : 24" :md="$store.state.user.tipo == 4 || $store.state.user.tipo == 6 ? 12 : 24">
                    <el-form-item label="Curso" prop="curso_id" :rules="[$requiredChange]" key="curso_id">
                        <el-select @change="getParametrosDiarioForTurma()" :disabled="editTurma" v-model="dados.curso_id" filterable>
                            <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6">
                    <el-form-item label="Qtd. aulas por dia letivo" prop="qtd_horarios" :rules="[$requiredBlur]" key="qtd_horarios">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.qtd_horarios" maxlength="191" v-mask="'#'"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Local diferenciado?" prop="local_diferenciado" :rules="[$requiredChange]" key="local_diferenciado">
                        <el-select v-model="dados.local_diferenciado">
                            <el-option v-for="(item, i) in $CONSTANTS.SALA_LOCAL_DIFERENCIADO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Horário Inicial de Funcionamento" prop="horario_inicial_funcionamento" key="horario_inicial_funcionamento">
                        <el-input v-model="dados.horario_inicial_funcionamento" maxlength="191" v-mask="'##:##'" v-on:blur="formatData('horario_inicial_funcionamento', 5)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Horário Final de Funcionamento" prop="horario_final_funcionamento" key="horario_final_funcionamento">
                        <el-input v-model="dados.horario_final_funcionamento" maxlength="191" v-mask="'##:##'" v-on:blur="formatData('horario_final_funcionamento', 5)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Dias da Semana" prop="diasFuncionamentoTurma" key="diasFuncionamentoTurma">
                        <el-select v-model="dados.diasFuncionamentoTurma" filterable multiple>
                            <el-option :key="1" label="DOMINGO" :value="1"></el-option>
                            <el-option :key="2" label="SEGUNDA" :value="2"></el-option>
                            <el-option :key="3" label="TERÇA" :value="3"></el-option>
                            <el-option :key="4" label="QUARTA" :value="4"></el-option>
                            <el-option :key="5" label="QUINTA" :value="5"></el-option>
                            <el-option :key="6" label="SEXTA" :value="6"></el-option>
                            <el-option :key="7" label="SÁBADO" :value="7"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- Integração SED-SP: dados que a SED exige e o SMGE não tinha. Só aparecem na escola com o envio ligado. -->
            <div v-if="sed.ativa" class="sed-bloco">
                <div class="sed-titulo">
                    <i class="fas fa-cloud"></i> Dados para a SED
                    <el-tag v-if="dados.codigo_sed" size="mini" type="success" style="margin-left: 8px;">Classe nº {{ dados.codigo_sed }}</el-tag>
                    <el-tag v-else size="mini" type="info" style="margin-left: 8px;">Será criada na SED ao salvar</el-tag>
                </div>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="6">
                        <el-form-item label="Turma na SED (letra)" prop="sed_turma" :rules="[$required]" key="sed_turma">
                            <el-input v-model="dados.sed_turma" maxlength="2" placeholder="Ex.: A"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="6">
                        <el-form-item label="Nº da sala" prop="sed_numero_sala" :rules="[$required]" key="sed_numero_sala">
                            <!-- A SED só aceita sala que esteja nas dependências cadastradas da escola. -->
                            <el-select v-if="salasSed.length" v-model="dados.sed_numero_sala" filterable placeholder="Selecione">
                                <el-option v-for="n in salasSed" :key="n" :label="'Sala ' + parseInt(n)" :value="n"></el-option>
                            </el-select>
                            <el-input v-else v-model="dados.sed_numero_sala" maxlength="3" v-mask="'###'" placeholder="Ex.: 7"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- Atividade complementar: um curso só no SMGE; o NÍVEL da complementação educacional (série na SED) é da turma. -->
                    <el-col :xs="24" :sm="8" :md="6" v-if="dados.tipo_ensino == 4">
                        <el-form-item label="Nível na SED" prop="sed_cod_serie_ano" :rules="[$requiredChange]" key="sed_cod_serie_ano">
                            <el-select v-model="dados.sed_cod_serie_ano" placeholder="Selecione">
                                <el-option v-for="n in niveisComplementacaoSed" :key="n.v" :label="n.l" :value="n.v"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="12" v-if="sed.unidades.length > 1">
                        <el-form-item label="Unidade da escola na SED" prop="sed_cod_unidade" key="sed_cod_unidade">
                            <el-select v-model="dados.sed_cod_unidade" clearable :placeholder="'Padrão da escola (' + sed.unidade_padrao + ')'">
                                <el-option v-for="u in sed.unidades" :key="u.codigo" :label="u.codigo + ' — ' + u.descricao" :value="u.codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>

            <el-row :gutter="10" v-if="dados.tipo_ensino == 4">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Atividade Complementar" prop="atividadesComplementares" :rules="[$requiredChange]" key="atividadesComplementares">
                        <el-select v-model="dados.atividadesComplementares" filterable multiple>
                            <el-option v-for="item in selectAtividadesComplementares" :key="item.id" :label="item.nome_atividade" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" v-if="dados.tipo_ensino == 3">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Tipos de Atendimentos Especializados" prop="tiposAtendimentosEspecializados" key="tiposAtendimentosEspecializados">
                        <el-select v-model="dados.tiposAtendimentosEspecializados" filterable multiple>
                            <el-option v-for="item in selectAtendimentosEspecializados" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="dados.tipo_ensino == 3">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Classe bilíngue de surdos tendo a Libras como língua de instrução, ensino, comunicação e interação e a língua portuguesa escrita como segunda língua">
                        <el-select v-model="dados.bilingue_libras">
                            <el-option :key="0" label="NÃO" :value="0"></el-option>
                            <el-option :key="1" label="SIM" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Multisseriada?" prop="multisseriada" key="multisseriada">
                        <el-select :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.multisseriada">
                            <el-option :key="0" label="NÃO" :value="false"></el-option>
                            <el-option :key="1" label="SIM" :value="true"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Multiperíodo?" prop="multi_periodos" key="multi_periodos">
                        <el-select :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4 && $store.state.user.tipo != 0 && $store.state.user.tipo != 12 && $store.state.user.tipo != 1" v-model="dados.multi_periodos">
                            <el-option :key="0" label="NÃO" :value="false"></el-option>
                            <el-option :key="1" label="SIM" :value="true"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="[0, 1, 3].includes(Number($store.state.user.tipo))">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Coordenador" prop="coordenador_id" key="coordenador_id">
                        <el-select v-model="dados.coordenador_id" filterable remote clearable
                            :remote-method="buscarCoordenador" :loading="loadCoordenador"
                            placeholder="Digite o nome do servidor..." style="width: 100%;">
                            <el-option v-for="s in servidoresCoordenador" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Secretário" prop="secretario_id" key="secretario_id">
                        <el-select v-model="dados.secretario_id" filterable remote clearable
                            :remote-method="buscarSecretario" :loading="loadSecretario"
                            placeholder="Digite o nome do servidor..." style="width: 100%;">
                            <el-option v-for="s in servidoresSecretario" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Metodologia de Avaliação" prop="metodo_avaliacao" key="metodo_avaliacao">
                        <el-select v-model="dados.metodo_avaliacao">
                            <el-option key="qualitativo" label="QUALITATIVO" value="qualitativo"></el-option>
                            <el-option key="quantitativo" label="QUANTITATIVO" value="quantitativo"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Disciplinas Principais" prop="areas_cobhecimento_principais" key="areas_cobhecimento_principais">
                        <el-select v-model="dados.areas_cobhecimento_principais" multiple>
                            <el-option v-for="(item, i) in selectParametrosDiario" v-if="!item.diversificada" :key="i" :label="item.nome_area" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="((dados.tipo_ensino == 1 || dados.tipo_ensino == 2) && dados.qtd_horarios > 2 && dados.turno != 2)">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Disciplina Diversificada" prop="areas_cobhecimento_diversificadas" key="areas_cobhecimento_diversificadas">
                        <el-select v-model="dados.areas_cobhecimento_diversificadas" multiple>
                            <el-option v-for="(item, i) in selectParametrosDiario" v-if="item.diversificada" :key="i" :label="item.nome_area" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>            
            
            <template v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6">
                <h3 class="u-mt-20 u-mb-20">Períodos Diário</h3>
                <el-row :gutter="10" v-for="(item, i) in dados.periodos_diario" :key="i"> 
                    <el-col :xs="24" :sm="23" :md="23">
                        <el-form-item label="Nome" :prop="`periodos_diario[${i}]`" :rules="[$requiredBlur]" :key="`periodos_diario[${i}]`">
                            <el-input v-model="dados.periodos_diario[i]"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="1" :md="1" class="u-text-right">
                        <el-button @click="removeLinhaPeriodo(i)" type="danger" plain style="margin-top: 21px;">
                            <i class="fas fa-trash-alt"></i>
                        </el-button>
                    </el-col>
                </el-row>
                <div class="u-text-right">
                    <el-button @click="adicionarLinhaPeriodo()" type="primary" plain>
                        <i class="fas fa-plus"></i> ADICIONAR PERIODO
                    </el-button>
                </div>
            </template>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <div class="u-text-right u-mt-15">
                        <el-button size="small" type="danger" @click="$emit('close')">FECHAR</el-button>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId', 'instituicao', 'periodo_letivo'],
    data: () => ({
        editTurma: false,
        loadingAtividadesComp: false,
        selectAtividadesComplementares: [],
        selectAtendimentosEspecializados: [],
        selectParametrosDiario: [],
        dados:{
            nome: '',
            inep: '',
            multisseriada: false,
            multi_periodos: false,
            data_abertura: '',
            data_conclusao: '',
            turno: '',
            local_diferenciado: '',
            qtd_vagas: '',
            situacao: 1,
            periodo_letivo_id: '',
            instituicao_id: '',
            curso_id: '',
            tipo_ensino: '',
            horario_inicial_funcionamento: '',
            horario_final_funcionamento: '',
            diasFuncionamentoTurma: [],
            atividadesComplementares: [],
            tiposAtendimentosEspecializados: [],
            bilingue_libras: '',
            qtd_horarios: '',
            areas_cobhecimento_principais: [],
            areas_cobhecimento_diversificadas: [],
            metodo_avaliacao: '',
            periodos_diario: [],
            coordenador_id: null,
            secretario_id: null,
            // Integração SED-SP
            sed_turma: '',
            sed_numero_sala: '',
            sed_cod_unidade: null,
            sed_cod_serie_ano: null
        },
        // Séries do tipo de ensino 26 (COMPLEMENTAÇÃO EDUCACIONAL) na SED — DadosBasicos/TipoEnsino, 18/09/2026.
        niveisComplementacaoSed: [
            { v: '1', l: '1º nível' }, { v: '2', l: '2º nível' }, { v: '3', l: '3º nível' }, { v: '4', l: '4º nível' }, { v: '5', l: '5º nível' },
            { v: '19', l: '6º ano (anos finais)' }, { v: '20', l: '7º ano (anos finais)' }, { v: '21', l: '8º ano (anos finais)' }, { v: '22', l: '9º ano (anos finais)' }
        ],
        sed: { ativa: false, unidade_padrao: null, unidades: [] },
        selectCursos: [],
        selectTiposEnsino: [],
        servidoresCoordenador: [],
        servidoresSecretario: [],
        loadCoordenador: false,
        loadSecretario: false

    }),
    computed: {
        // Salas (dependências) da unidade escolhida — ou da unidade padrão da escola.
        salasSed(){
            const codigo = this.dados.sed_cod_unidade || this.sed.unidade_padrao;
            const unidade = (this.sed.unidades || []).find(u => u.codigo === codigo);
            return unidade ? unidade.salas : [];
        }
    },
    mounted(){

        this.dados.instituicao_id = this.instituicao;
        this.dados.periodo_letivo_id = this.periodo_letivo;
        this.getIntegracaoSed();

        this.$axios.all([
            this.getAtividadesComplementares(), 
            this.getAtendimentosEspecializados()
        ]).then(this.$axios.spread((atividades, atendimentos)=>{

            this.selectAtividadesComplementares = JSON.parse(JSON.stringify(atividades.data));
            this.selectAtendimentosEspecializados = JSON.parse(JSON.stringify(atendimentos.data));

        })).catch((error) => { this.$store.commit('throwException', error); });

    },
    methods:{

        adicionarLinhaPeriodo(){

            this.dados.periodos_diario.push('');
        },

        removeLinhaPeriodo(i){

            this.dados.periodos_diario.splice(i, 1);
        },
        getParametrosDiarioForTurma(){

            if(!this.dados.curso_id || this.dados.turno === '' || this.dados.turno === null) {
                return;
            }

            let c = this.dados.curso_id;
            let t = this.dados.turno;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getParametrosDiarioForTurma/${c}/${t}`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectParametrosDiario = JSON.parse(JSON.stringify(response.data.disciplinas));

                if(!this.editTurma){
                    
                    this.dados.qtd_horarios = response.data.parametros.qtd_horarios;
                    this.dados.areas_cobhecimento_principais = response.data.parametros.disciplinas;
                    this.dados.metodo_avaliacao = response.data.parametros.metodo_avaliacao;
                    this.dados.periodos_diario = response.data.parametros.periodos_diario;
                }

            }).catch((error) => { this.$store.commit('throwException', error); });      

        },
        getAtividadesComplementares(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/atividade-complementar/getAll`, this.$store.getters.getHeaderAuth);
        },
        getAtendimentosEspecializados(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/tipo-atendimento-especializado/getAll`, this.$store.getters.getHeaderAuth);
        },
        buscarCoordenador(q){

            if(!q || q.length < 2){ this.servidoresCoordenador = []; return; }
            this.loadCoordenador = true;
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(response => { this.servidoresCoordenador = response.data || []; this.loadCoordenador = false; })
                .catch(() => { this.loadCoordenador = false; });
        },
        buscarSecretario(q){

            if(!q || q.length < 2){ this.servidoresSecretario = []; return; }
            this.loadSecretario = true;
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(response => { this.servidoresSecretario = response.data || []; this.loadSecretario = false; })
                .catch(() => { this.loadSecretario = false; });
        },
        getCursosByTipoEnsino(){

            if(!this.editTurma)
                this.dados.curso_id = '';

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getCursosByTipoEnsino/` + this.dados.tipo_ensino, this.$store.getters.getHeaderAuth).then(response => {

                this.selectCursos = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        // A escola envia turmas à SED? Se sim, o formulário pede letra, sala e (quando houver mais de uma) a unidade.
        getIntegracaoSed(){

            const instituicao = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : this.instituicao;

            if(!instituicao) return;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sed/escola/` + instituicao, this.$store.getters.getHeaderAuth).then(response => {

                this.sed = response.data;

            }).catch(() => { this.sed = { ativa: false, unidade_padrao: null, unidades: [] }; });
        },
        getTurmaById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
                // Pré-carrega as opções dos selects remotos para exibir o nome já salvo.
                if(response.data.coordenador) this.servidoresCoordenador = [response.data.coordenador];
                if(response.data.secretario) this.servidoresSecretario = [response.data.secretario];
                this.getCursosByTipoEnsino(response.data.tipo_ensino);
                this.getParametrosDiarioForTurma()

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        // `throw` pode vir como texto (legado), objeto ou lista (padrão da integração SED).
        mostrarThrow(t){

            if(Array.isArray(t)) window.eventBus.$emit('throw', t);
            else window.eventBus.$emit('alert', {msg: (t && t.msg) ? t.msg : t, type: 'warning'});
        },
        onSubmitTurma(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                let dados = JSON.parse(JSON.stringify(this.dados));

                window.eventBus.$emit('loading', true);

                dados.instituicao_id = this.$store.state.config.instituicao.id;
                dados.periodo_letivo_id = this.$store.state.config.periodo.id;

                if(this.editTurma){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/update/${dados.id}`, dados, this.$store.getters.getHeaderAuth).then(response => {

                         if(response.data.throw){

                            this.mostrarThrow(response.data.throw);
                            window.eventBus.$emit('loading', false);

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitTurma');
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/store`, dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);

                        // Antes o cadastro mostrava "Sucesso" mesmo com erro: a recusa da SED precisa chegar ao usuário.
                        if(response.data && response.data.throw){
                            this.mostrarThrow(response.data.throw);
                            return;
                        }

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitTurma');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{

                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getTurmaById(value);
                    this.editTurma = true;
                }
            }
        },
    }
}
</script>

<style scoped>
.sed-bloco { border: 1px solid #d9ecff; background: #f4f9ff; border-radius: 4px; padding: 10px 12px 0; margin-bottom: 14px; }
.sed-titulo { font-size: 13px; font-weight: bold; color: #337ab7; margin-bottom: 8px; }
</style>
